<template>
    <div class="detail">
        <!-- 头部 -->
        <navbar-header></navbar-header>

        <!-- 背景 -->
        <div class="bg_box"></div>

        <!-- 新闻详情 -->
        <detail-box :info="info" :nextInfo="nextInfo" :preInfo="preInfo" :isZan="isZan" :isCollect="isCollect" @update="updateNews"></detail-box>

        <!-- 底部 -->
        <nav-footer></nav-footer>
    </div>
</template>

<script>
    import NavbarHeader from "../components/index/NavbarHeader"
    import NavFooter from "../components/common/NavFooter"
    import DetailBox from "../components/news/DetailBox"
    import { mapGetters } from "vuex"
    export default {
        components: {
            NavbarHeader,
            NavFooter,
            DetailBox,
        },
        computed: {
            newsId () {
                return Number( this.$route.params.id )
            },
            cateId () {
                return Number( this.$route.query.cate_id )
            },
            specialReportId () {
                return Number( this.$route.query.specialReportId )
            },
            ...mapGetters(['token'])
        },
        watch: {
            newsId () {
                this.getNewsDetail()
            }
        },
        data() {
            return {
                info: {},
                nextInfo: {},
                preInfo: {},
                isZan: 0, 
                isCollect: 0,
            }
        },
        created () {
            this.getNewsDetail()
            if ( this.token ) {
                this.getNewsFavStatus()
                this.getNewsZanStatus()
            }
        },
        methods: {
            // 获取新闻详情
            async getNewsDetail () {
                let info = {}
                let { cateId, newsId, specialReportId } = this 
                if ( cateId ) {
                    info = { 
                        cateId,
                        newsId
                    }
                } else if ( specialReportId ) {
                    info = {
                        newsId,
                        specialReportId
                    }
                }
                let res = await this.$axios.post("/lencon/pc/news/newsDetail", info)
                if ( res.data.code == 1 ) {
                    this.info = res.data.data
                    this.nextInfo = res.data.lastNews
                    this.preInfo = res.data.nextNews
                }
            },

            // 新闻收藏状态
            async getNewsFavStatus () {
                let { token, newsId } = this 
                let res = await  this.$axios.post("/lencon/pc/news/news/is_collection", { token, news_id: newsId })
                if ( res.data.code == 1 ) {
                    this.isCollect = res.data.is_collection
                    console.log("收藏" + this.isCollect )
                }

            },
            // 新闻点赞状态
            async getNewsZanStatus () {
                let { token, newsId } = this 
                let res = await  this.$axios.post("/lencon/pc/news/news/is_zan", { token, news_id: newsId })
                console.log( res.data )
                if ( res.data.code == 1 ) {
                    this.isZan = res.data.is_zan
                    console.log( "点赞" + this.isZan )
                }

            },
            // 更新新闻
            updateNews () {
                this.getNewsDetail()
                this.getNewsFavStatus()
                this.getNewsZanStatus()
            }
        }
    }
</script>

<style lang="scss" scoped>
.detail {
    position: relative;
    left: 0;
    top: 0;
    .bg_box {
        width: 100%;
        height: 746px;
        margin: 0 auto;
        background: url("../assets/static/index/btm_bg.jpg") 0 0 no-repeat;
        background-size: 100% 100%;
        position: absolute;
        left: 0;
        top: 269px;
        z-index: -1;
    }
}
</style>